import { render, staticRenderFns } from "./TabBox.vue?vue&type=template&id=fa8b6ace&scoped=true"
import script from "./TabBox.vue?vue&type=script&lang=js"
export * from "./TabBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa8b6ace",
  null
  
)

export default component.exports